<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g clip-path="url(#a)"><path fill-rule="evenodd" d="M5 4a1 1 0 00-1 1v4a1 1 0 002 0V7.414l5 5V19a1 1 0 102 0v-7a1 1 0 00-.293-.707L7.414 6H9a1 1 0 000-2H5zm13 3.414V9a1 1 0 102 0V5a1 1 0 00-1-1h-4a1 1 0 100 2h1.586l-2.793 2.793a1 1 0 001.414 1.414L18 7.414z"/></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"/></clipPath></defs></svg>